import { useTranslations } from '@vocab/react';
import { isPast, parse } from 'date-fns';
import translations from '../.vocab';

export interface Invalid {
  valid: false;
  errorMessage: string;
}

export interface Valid {
  valid: true;
  expiredDate: Date;
}

export const useValidateExpiryDate = () => {
  const { t } = useTranslations(translations);
  return {
    getValidationExpiryDateMessage: (
      expiryDateString: string,
    ): Valid | Invalid => {
      const expiredDate = parse(
        `${expiryDateString} +11 23:59:59`,
        t('Expiry date format'),
        new Date(),
      );

      if (isNaN(expiredDate.getTime())) {
        return {
          valid: false,
          errorMessage: t('Enter the expiry date as DD/MM/YYYY'),
        };
      }

      if (isPast(expiredDate)) {
        return {
          valid: false,
          errorMessage: t('Expiry date cannot be in the past'),
        };
      }

      return {
        expiredDate,
        valid: true,
      };
    },
  };
};

export default useValidateExpiryDate;
